import * as React from 'react';

export const Warehouse = () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4V5V6V15H2V6H14V15H16V6V5V4L8 0L0 4ZM7 12H4V15H7V12ZM8 12H11V15H8V12ZM7 8H4V11H7V8Z"
      fill="#737A8E"
    />
  </svg>
);
